import AuthManager from "./AuthManager";
import Keycloak, {KeycloakProfile} from "keycloak-js";
import { setKeycloak } from '@coremarine/fe-cc-lib';


class AuthManagerNewAuth extends AuthManager<object, object> {
    private _refreshPeriod = 240000;
    constructor (url: string, client: {id: string, realm: string, group: string}, redirectUrl: string) {
        super(url, client, redirectUrl);
        this._clientGroup = client.group;
    }

    
    login(credentials): Promise<KeycloakProfile> {
        return this.auth();
    }

    auth(): Promise<KeycloakProfile> {        
        return setKeycloak(
            this._keycloakUrl,
            this._realm,
            this._clientID,
            this._clientGroup,
            "/user-api/api/v1/"
        ).then(d => {
            this._keycloak = d.keycloak;
            this.refresh = d.refreshedAuthToken;
            if(!d.token) {
                return this._keycloak.login({
                    redirectUri: this._redirectUrl,  
                }).then(d => {
                    this._setCookie();
                    console.log(d)                          
                    this.setAutoRefresh();
                    return {
                        ...d.user,
                        username: this.tokenParsed.preferred_username,
                        roles: this.tokenParsed.roles
                    };
                })
                .catch(e => {console.log(e)});
            } else {
                this._setCookie();
                this.setAutoRefresh();
                return {
                    ...d.user,
                    username: this.tokenParsed.preferred_username,
                    roles: this.tokenParsed.roles,
                    role: d.user?.role?.name
                };
            }            
        });
    }
     setAutoRefresh() {
        console.log("REFRESH IN", this._refreshPeriod)
        if(this._timer) clearInterval(this._timer);

        this._timer = setTimeout(() => {
            console.log("REFRESHING")
            this.refresh().then(() => {
                this._timer = null;
                this.setAutoRefresh();
            });           
        }, this._refreshPeriod);
    }
}

export default AuthManagerNewAuth;